import { render, staticRenderFns } from "./td-primary.vue?vue&type=template&id=7195218f&scoped=true&"
import script from "./td-primary.vue?vue&type=script&lang=js&"
export * from "./td-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195218f",
  null
  
)

export default component.exports